<template>
  <div>
    <div class="grid grid-cols-3 border-t pt-8 pb-2 text-gray-400">
      <span class="font-semibold">
        {{ wordsFirstLetterToUpper(fieldName, "_") }}
      </span>
      <!-- the accessor goes -1 because we made it user-friendly (start from 1 not 0 bc of array indexing) -->
      <div
        :class="`justify-self-center font-semibold text-${
          STATUS_COLORS[fieldData[currentEntryIndex - 1].match_type]
        }-500`"
      >
        <icon-base
          v-if="fieldData[currentEntryIndex - 1].match_type === 'exact'"
          class="mr-2"
          :icon="IconSuccessRoundBig"
        />
        <icon-base
          v-else
          class="mr-2"
          height="16"
          width="16"
          :icon="IconFailure"
        />
        <span>
          {{
            wordsFirstLetterToUpper(fieldData[currentEntryIndex - 1].match_type)
          }}
        </span>
      </div>
      <fraud-entries-dropdown
        v-if="Object.keys(entryOptions).length > 1"
        class="max-w-max justify-self-end"
        placeholder="Entries"
        :options="entryOptions"
        :value="currentEntryIndex"
        @change="handleEntryChange"
      />
    </div>
    <div class="pt-4 pb-8">
      <fraud-details-recursive
        v-if="currentDetails"
        :field-name="fieldName"
        :details="currentDetails"
      />
      <span v-else>No additional details.</span>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";

import { wordsFirstLetterToUpper } from "@/helpers/formatting";

import FraudDetailsRecursive from "./FraudDetailsRecursive.vue";
import FraudEntriesDropdown from "./FraudEntriesDropdown.vue";
import IconFailure from "@/components/icons/IconFailure.vue";
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";

const STATUS_COLORS = {
  ["fuzzy"]: "red",
  ["exact"]: "green",
};

const ADDRESS_FIELDS = ["zipcode", "city", "state"];
const ADDRESS_PROPERTY_NAME = "addresses";

export default {
  components: {
    FraudDetailsRecursive,
    FraudEntriesDropdown,
  },

  props: {
    fieldName: {
      type: String,
      required: true,
    },
    fieldData: {
      type: Object,
      required: true,
    },
    identity: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // will always go from the first entry
    const currentEntryIndex = ref(1);

    const currentDetails = computed(() => {
      let propertyName;

      if (ADDRESS_FIELDS.includes(props.fieldName.toLowerCase())) {
        propertyName = ADDRESS_PROPERTY_NAME;
      } else {
        propertyName = Object.keys(props.identity).find((id) =>
          id.toLowerCase().includes(props.fieldName.toLowerCase())
        );
      }
      if (!propertyName) {
        return null;
      }

      return (
        props.identity[propertyName]?.[
          props.fieldData[currentEntryIndex.value - 1]?.match_index
        ] || null
      );
    });

    const entryOptions = computed(() =>
      props.fieldData.reduce(
        // incrementing just to make the entry list user-friendly
        (acc, _, index) => ({ ...acc, [index + 1]: index + 1 }),
        {}
      )
    );

    const handleEntryChange = (val) => {
      currentEntryIndex.value = val;
    };

    return {
      IconFailure,
      IconSuccessRoundBig,
      currentDetails,
      currentEntryIndex,
      handleEntryChange,
      entryOptions,
      wordsFirstLetterToUpper,
      STATUS_COLORS,
    };
  },
};
</script>
